import { Collapse, CollapseItem, Upload, DatePicker, TimeSelect, Table, TableColumn, Tag, Input, Button, Select, Option, Popover } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import { Switch as LSwitch } from '@/components/index';
import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
const svc = new ResourceSvc();

export default {
    name: 'dashboardCopyRace',
    props: ['userId'],
    components: {
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Table.name]: Table, [TableColumn.name]: TableColumn, [DatePicker.name]: DatePicker, [TimeSelect.name]: TimeSelect, [Tag.name]: Tag, [Input.name]: Input, [Select.name]: Select, [Option.name]: Option, [Upload.name]: Upload, [Button.name]: Button, [Popover.name]: Popover, LSwitch,
    },
    data() {
        return {
            isProcessing: false,
            errorMessage: null,
            tableData: [],
            years: [],
            selectedYear: 0,
            selectedTypeBySport: null
        };
    },
    computed: {
        racesBySelectedYear() {
            var self = this;
            if (!self.tableData) {
                return []
            }
            var data = self.tableData.filter(x => {
                return x.year == self.selectedYear;
            });
            if (data && data.length) {
                var result = [];
                data[0].races.forEach(x => {
                    if (x.typeBySport == self.selectedTypeBySport) {
                        result.push(x);
                    }
                });
                return result;
            }
            return [];
        },
        typesBySportBySelectedYear() {
            var self = this;
            if (!self.tableData) {
                return []
            }
            var data = self.tableData.filter(x => {
                return x.year == self.selectedYear;
            });
            var result = [];
            if (data && data.length) {
                data[0].races.forEach(x => { result.push(x.typeBySport); });;
                result = result.filter(this.onlyUnique);
            }

            return result;
        },
        domain() {
            return process.env.url.oldApp;
        }
    },
    methods: {
        onlyUnique(value, index, data) {
            return data.indexOf(value) === index;
        },
        getData() {
            var self = this;
            self.isProcessing = true;
            svc.getRacesManagedByUser().then(response => {
                var allData = response.body;
                self.isProcessing = false;
                if (!allData) {
                    self.errorMessage = "Something went wrong!";
                    return;
                }
                if (!allData.isSuccess) {
                    self.errorMessage = allData.message;
                    return;
                }
                else {
                    self.errorMessage = null;
                    self.tableData = allData.racesByYears;
                    self.years = allData.years;
                    if (self.years && self.years.length) {
                        self.selectedYear = self.years[0];
                    }
                }
                self.$console();
                self.$console({ races: self.tableData });

                return self.tableData;
            }, () => {
                self.isProcessing = false;
                self.errorMessage = "Something went wrong, please contact with dev team!";
            });
        },
        showError(message) {
            if (!message) {
                message = 'Something went wrong. Incorrect request!';
            }
            this.$notify({
                message: message,
                type: 'danger',
                timeout: 100000
            });
        },
        showSuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 10000
            });
        }
    },
    created() {
        var self = this;
        self.getData();
        EventBus.$emit("user-load-dashboard-card", 0);
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/copy-race/copy-race.js